import { createSelector } from '@reduxjs/toolkit'

import { extractAccessories } from '../utils/extracters';
import { isPasteProduct } from "../utils/helpers";

export const selectAccessoriesInfo = (state) => state.accessories?.accessoriesListInfo;
export const selectUserAccessories = (state) => state.accessories?.accessories;
export const selectAccessoriesToDestroy = (state) => state.accessories?.accessoriesToDestroy;

export const selectAccessoryProducts = createSelector([selectAccessoriesInfo], (accessoriesListInfo) => {
  return {
    paste_products: accessoriesListInfo ? accessoriesListInfo.filter((accessory) => isPasteProduct(accessory)) : [],
    other_products: accessoriesListInfo ? accessoriesListInfo.filter((accessory) => !isPasteProduct(accessory)): [],
  };
});

export const selectUserAccessoriesDetail = createSelector([selectUserAccessories, selectAccessoriesInfo], (accessories, accessoriesListInfo) => {
  const user_accessories = accessories && accessories.length ? accessories : [];
  return user_accessories.map((accessory) => {
    const accessoryInfo = accessoriesListInfo.find((info) => info.id === accessory.product_id);
    const product_title = accessoryInfo.selected_variant.sku && accessoryInfo.selected_variant.sku !== '' ? accessoryInfo.selected_variant.sku : accessoryInfo.name;

    return {
      ...accessory,
      product_title,
      item_total: accessoryInfo.selected_variant.price * accessory.quantity,
    }
  });

});

export const selectAccessoryCartInfo = createSelector([
  selectUserAccessories, 
  selectAccessoriesInfo, 
  selectAccessoriesToDestroy,
  ], (
    accessories, 
    accessoriesListInfo, 
    accessoriesToDestroy,
  ) => {

    const data_for_forms = accessories && accessories.length ? {accessories} : null;
    const accessories_to_destroy = accessoriesToDestroy && accessoriesToDestroy.length ? accessoriesToDestroy : [];

    return {
      accessoriesDataForForms: data_for_forms,
      accessoriesToDestroy: accessories_to_destroy,
      accessoryProps: extractAccessories({ accessories, accessoriesListInfo }),
    };
  }
);